import { useAuthenticated } from "nate-react-api-helpers/lib/Auth";
import { useCallback } from "react";
export function useUser() { const u = useAuthenticated(); const usr = u.lastPingResult; return usr; }
export function usePermission() { const u = useUser(); return useCallback((input, render) => { return render(hasPermission(u, input)); }, [u]); }
export function hasPermission(input, perm) { return !!input && input.permissions.indexOf(perm) !== -1; }
